import type { Directive, DirectiveBinding } from "vue";

interface LongPressBindingValue {
	handler: (e: Event) => void;
	duration?: number;
}

const LongPressDirective: Directive = {
	mounted(el: HTMLElement, binding: DirectiveBinding<LongPressBindingValue>) {
		const { handler, duration = 1000 } = binding.value;
		let pressTimer: ReturnType<typeof setTimeout> | null = null;

		// 创建统一的事件处理函数
		const start = (e: Event) => {
			if (e.type === "click" && (e as MouseEvent).button !== 0) return;

			if (!pressTimer) {
				pressTimer = setTimeout(() => {
					handler(e);
					pressTimer = null;
				}, duration);
			}
		};

		const cancel = () => {
			if (pressTimer) {
				clearTimeout(pressTimer);
				pressTimer = null;
			}
		};

		// 保存事件处理函数到元素属性以便卸载时使用
		el._longPressHandlers = { start, cancel };

		// 绑定事件监听器
		el.addEventListener("mousedown", start);
		el.addEventListener("touchstart", start);
		el.addEventListener("mouseup", cancel);
		el.addEventListener("mouseleave", cancel);
		el.addEventListener("touchend", cancel);
		el.addEventListener("touchcancel", cancel);
	},

	unmounted(el: HTMLElement) {
		// 移除事件监听器
		if (el._longPressHandlers) {
			const { start, cancel } = el._longPressHandlers;
			el.removeEventListener("mousedown", start);
			el.removeEventListener("touchstart", start);
			el.removeEventListener("mouseup", cancel);
			el.removeEventListener("mouseleave", cancel);
			el.removeEventListener("touchend", cancel);
			el.removeEventListener("touchcancel", cancel);
		}
	},
};

// 类型扩展
declare global {
	interface HTMLElement {
		_longPressHandlers?: {
			start: (e: Event) => void;
			cancel: () => void;
		};
	}
}

export default LongPressDirective;
